var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTable',{attrs:{"title":"Appuntamenti","headers":_vm.headers,"items":_vm.items,"total-rows":_vm.totalRows,"loading":_vm.loading,"elevation":0,"hide-title":_vm.hideTitle},on:{"refresh":_vm.onRefresh},scopedSlots:_vm._u([{key:"item.date_appointment",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("momentOr")(item.date_appointment,'DD/MM/YYYY HH:mm', '-'))+" ")]}},{key:"item.description",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("placeholder")(item.description,'-'))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }